import { useForm } from "react-hook-form";
import { Button, Icon, Loading, TextInput, Typography } from "@/components/atoms";
import { getErrorMessages } from "@/helpers/reduxHelpers";
import { useAddPricingProfileMutation } from "@/redux/apis/config/pricing/tripCost";
import { addToast } from "@/utils";
import { useNavigate } from "react-router-dom";

interface AddPricingProfileFormProps {
  onClose: () => void;
}

export const AddPricingProfileForm = ({ onClose, ...props }: AddPricingProfileFormProps) => {
  const navigate = useNavigate();
  const [addPricingProfile, { isLoading }] = useAddPricingProfileMutation();
  const {
    register,
    handleSubmit,
    formState: { isDirty },
  } = useForm<{ name: string }>({
    defaultValues: { name: "" },
  });

  const onSubmit = handleSubmit((data) => {
    addPricingProfile({ name: data.name })
      .unwrap()
      .then((data) => {
        onClose();
        addToast("success", "Successfully Added New Pricing Profile");
        navigate(data.uuid);
      })
      .catch((e) => getErrorMessages(e).forEach((m) => addToast("danger", m)));
  });

  return (
    <>
      <div className="flex items-center">
        <div>
          <Typography variant="title">Add Pricing Profile</Typography>
        </div>
        <button type="button" className="ml-auto rounded-md text-black" onClick={onClose}>
          <span className="sr-only">Close</span>
          <Icon name="close" isCustom size="lg" aria-hidden="true" />
        </button>
      </div>
      <form id="add-pricing-profile-form" className="relative" onSubmit={onSubmit} {...props}>
        {isLoading && <Loading />}
        <div className="mt-3 flex flex-1 flex-col gap-y-8">
          <div>
            <Typography variant="paragraph">Fixed Pricing Profile Name</Typography>
            <TextInput placeholder="Enter Pricing Profile Name" maxLength={65} required {...register("name")} />
          </div>
          <div>
            <Button variant="primary" type="submit" form="add-pricing-profile-form" size="lg" className="w-full" disabled={!isDirty}>
              Add Pricing Profile
            </Button>
          </div>
        </div>
      </form>
    </>
  );
};
